// @flow
import React, { Component } from "react";
import moment from "moment";
import I18n from "../../i18n/I18n";
import Helper from "../../helper/Helper";
import styles from "./InvoiceListMobile.scss";
import Icon from "../common/Icon";
import Button from "../common/button/Button";

class InvoiceListMobile extends Component {
  render() {
    const data = this.props.data || "";

    const invoiceListMobile = data
      ? data.map((statement, index) => {
          return (
            <div className={styles.ctr} key={index}>
              <div className={styles.flexer}>
                <div className={styles.statusCtr}>
                  <div className={styles.date}>
                    {statement.invoice_no}
                    <div className={styles.txnType}>
                      <strong>
                        {I18n.getText("statement.date", {}, "Date")} :{" "}
                      </strong>
                      {moment(statement.invoice_date).format("YYYY-MM-DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.wrapper}>
                  <div className={styles.btnWrapper}>
                    <Button
                      className={styles.btnCtr}
                      variant="transparent"
                      onClick={() =>
                        this.props.exportInvoice(statement.invoice_no)
                      }
                    >
                      <Icon name="download" className={styles.printIcon} />
                    </Button>
                    <a
                      href="https://invoice.noonstg.com/invoice/974/P00974-IABA000372"
                      target="_blank"
                    >
                      <Button className={styles.btnCtr} variant="transparent">
                        <Icon name="print" className={styles.printIcon} />
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
              <div className={styles.attrCtr}>
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("statement.total-item", {}, "Total Items")}
                  </h6>
                  <div className={styles.attrVal}>{statement.no_of_items}</div>
                </div>
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("statement.currency", {}, "Currency")}
                  </h6>
                  <div className={styles.attrVal}>
                    {I18n.formatCurrency({ currency: statement.invoice_ccy })}
                  </div>
                </div>
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("statement.amount-invoice", {}, "Amount")}
                  </h6>
                  <div className={styles.positive}>
                    {I18n.formatCurrency(
                      Helper.formatPrice(
                        statement.total_incl_vat,
                        statement.invoice_ccy
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : "";

    return <div>{invoiceListMobile}</div>;
  }
}

InvoiceListMobile.propTypes = {};

InvoiceListMobile.getDefaultProps = {};

export default InvoiceListMobile;



// WEBPACK FOOTER //
// ./src/components/statement/InvoiceListMobile.js